import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/Table.module.css';

const Table = ({ columns, rows, keyField = 'id', className = '' }) => {
    return (
        <div className={styles.tableWrapper}>
            <table className={`${styles.table} ${className}`.trim()}>
                <thead className={styles.thead}>
                    <tr>
                        {columns.map(col => (
                            <th key={col.key} style={{ textAlign: col.align || 'left', ...col.style }}>{col.title}</th>
                        ))}
                    </tr>
                </thead>

                {rows && rows.length > 0 && (
                    <tbody className={styles.tbody}>
                        {(rows || []).map(row => (
                            <tr key={row[keyField]} className={styles.row}>
                                {columns.map(col => (
                                    <td key={col.key} style={{ textAlign: col.align || 'left', ...col.style }}>
                                        {col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                )}

                {rows && rows.length === 0 && (
                    <tbody className={styles.tbody}>
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: 'center' }}>No data</td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    );
};

Table.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        title: PropTypes.node.isRequired,
        dataIndex: PropTypes.string,
        render: PropTypes.func,
        align: PropTypes.oneOf(['left', 'right', 'center']),
        style: PropTypes.object,
    })).isRequired,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    keyField: PropTypes.string,
    className: PropTypes.string,
};

export default memo(Table);
